import { getAuth, signOut } from "firebase/auth";
import { firebaseApp } from "./firebase";
import i18n from 'i18next';

const auth = getAuth(firebaseApp);

export async function apiRequest(path, method = "GET", data) {
  const accessToken = auth.currentUser
    ? await auth.currentUser.getIdToken()
    : undefined;

  return fetch(`/api/${path}`, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: data ? JSON.stringify(data) : undefined,
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === "error") {
        // Automatically signout user if accessToken is no longer valid
        if (response.code === "auth/invalid-user-token") {
          signOut(auth);
        }

        throw new CustomError(response.code, response.message);
      } else {
        return response.data;
      }
    });
}

// Create an Error with custom message and code
export function CustomError(code, message) {
  const error = new Error(message);
  error.code = code;
  return error;
}

export function floatString(n, digits = 6) {
  const locale = i18n.resolvedLanguage
  if (isNaN(n)) return (0).toLocaleString(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits});
  return Number.isInteger(n) ? n.toLocaleString(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits}) : n.toLocaleString(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits});
}

export function elipsisMiddle(str) {
    return str.substr(0, 10) + '...' + str.substr(str.length-10, str.length);
}
